import "./feature.css"

export function Feature({ feature, heading, description }){
    return (
        <div className="d-flex flex-column align-items-center">
            <div className="d-flex cntr rounded-circle feature mb-3">
                <div className={`w-75 h-75 bg-black rounded-circle ${feature}`}></div>
            </div>
            <div className="feature-heading text-center"><strong>{heading}</strong></div>
            <div className="feature-description text-center">{description}</div>
        </div>
    )
}